import { jsxs, jsx } from "react/jsx-runtime";
import { FontSize600 } from "@nxt-costco-com/forge-design-tokens";
import { AdSetTitle } from "../AdSet/AdSetTitle.js";
import { FourCorners } from "../FourCorners/index.js";
import { CostcoBox } from "../../Util/CostcoBox.js";
import { Container } from "./styles.js";
const FourCornersCategoryTile = ({
  bodyBackgroundColor,
  categoryTiles,
  ignoreBackground,
  titleProps
}) => {
  return /* @__PURE__ */ jsxs(
    Container,
    {
      bodyBackgroundColor,
      ignoreBackground,
      children: [
        titleProps && /* @__PURE__ */ jsx(
          AdSetTitle,
          {
            ...titleProps,
            titleGridSx: {
              display: "flex",
              justifyContent: "center"
            },
            titleLinkSx: {
              lineHeight: "20px",
              marginBottom: 0
            },
            titleSx: {
              fontSize: `${FontSize600}`
            },
            isAdSetCostco: true
          }
        ),
        /* @__PURE__ */ jsx(
          CostcoBox,
          {
            sx: {
              alignItems: "center",
              display: "flex",
              flex: 1,
              flexDirection: "column",
              justifyContent: "center",
              minWidth: "100%"
            },
            children: /* @__PURE__ */ jsx(
              FourCorners,
              {
                data: categoryTiles,
                isAdSetCostco: true,
                type: "category"
              }
            )
          }
        )
      ]
    }
  );
};
export {
  FourCornersCategoryTile
};
